/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
module.exports = {
    tag: 'ox',
    quality: 0.1,
    toughness: 1,
    strength: 1,
    speed: -0.4
}